import React, { forwardRef } from 'react';
import PicDefault from './pictureDefault';
var Picture = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(PicDefault, Object.assign({}, props, {
    ref: ref
  }));
});
Picture.displayName = 'Picture';
export default Picture;